import dayjs from 'dayjs';

/** Display format for date attribute values across the attribute table and tool dropdowns. */
export const DISPLAY_DATE_FORMAT = 'MM-DD-YYYY';

// ISO date (`YYYY-MM-DD`) or full timestamp (`...T...` / space-separated datetime).
const DATE_LIKE = /^\d{4}-\d{2}-\d{2}(?:[T\s]\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]\d{2}:?\d{2})?)?$/;

/**
 * Formats API date/timestamp values for UI display as MM-DD-YYYY.
 * Non-date values are returned unchanged. Keep the raw value for queries/edits —
 * this is display-only.
 */
export const formatDisplayDate = (value: unknown): string => {
  if (value == null || value === '') return value == null ? '' : String(value);

  if (value instanceof Date) {
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.format(DISPLAY_DATE_FORMAT) : String(value);
  }

  if (typeof value !== 'string') {
    return String(value);
  }

  const trimmed = value.trim();
  if (!DATE_LIKE.test(trimmed)) {
    return value;
  }

  const parsed = dayjs(trimmed);
  if (!parsed.isValid()) {
    return value;
  }

  return parsed.format(DISPLAY_DATE_FORMAT);
};
